import moment from "moment";

export const PAGE_TITLE = "Processing Types";
export const PAGE_SINGLE_TITLE = "Processing Type";
export const LINK_URL = "processingtypes";
export const SEARCH_TERMS = ["name"];
export const inputFields = {
  name: {
    type: "string",
    required: true,
    title: "Name",

    inputType: "text",
  },
};
export const initialValues = {
  name: "",
};

export const view_all_table = [{ name: "Name", value: "name" }];
